import React from "react";
import { useAuth } from "./hooks/use-auth";
import { ConnectScreen } from "./components/connect";
import { Dashboard } from "./components/dashboard";
import { Text, LoadingIndicator, Rows, Button } from "@canva/app-ui-kit";

export function App() {
  const { state, connect, disconnect, selectOrg } = useAuth();

  return (
    <div style={{ padding: 16 }}>
      {state.status === "loading" && (
        <Rows spacing="2u">
          <Text>Loading Profitual...</Text>
          <LoadingIndicator />
        </Rows>
      )}

      {state.status === "unlinked" && (
        <ConnectScreen onConnect={connect} />
      )}

      {state.status === "linking" && (
        <Rows spacing="2u">
          <Text>Complete sign-in in the browser tab that just opened, then come back here.</Text>
          <LoadingIndicator />
        </Rows>
      )}

      {state.status === "linked" && (
        // key on orgId so Dashboard fully resets (scenario/model/month state) when switching orgs
        <Dashboard
          key={state.orgId}
          orgId={state.orgId}
          orgName={state.orgName}
          orgs={state.orgs}
          onSelectOrg={selectOrg}
          onLinkAnother={connect}
          onDisconnect={disconnect}
        />
      )}

      {state.status === "error" && (
        <Rows spacing="2u">
          <Text tone="critical">{state.message}</Text>
          <Button variant="secondary" onClick={connect}>
            Try again
          </Button>
        </Rows>
      )}
    </div>
  );
}
